import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useInsuranceProduct = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      title: t('insuranceProducts', { ns: 'common' }),
      items: [
        {
          label: t('carInsurance', { ns: 'common' }),
          href: '/car-insurance',
        },
      ],
    }),
    [],
  );
};
